import { gql } from '@apollo/client/core';

export const DEFAULT_SET_FIELDS = gql`
  fragment DefaultSetFields on DefaultSet {
    id
    defaults
  }
`;
